import $ from 'jquery';
import { getAuthentication } from '../api/ispyb.js';
import { fetchSessions, fetchSessionsByDate } from './sessions.js';
import { fetchProposals } from './proposals.js';
import { loadJobs } from './jobs.js';
import _ from 'lodash';
import moment from 'moment';
import ISPyB from '../config/config.js';

import { LOG_IN, LOGGED_IN, LOG_OUT, LOGIN_ERROR } from '../constants/ActionTypes';

export function doLogOut(user) {
  return { type: LOG_OUT, user };
}

export function setLoginInfo(user) {
  return { type: LOGGED_IN, user };
}

function doLogin(server, username, password, site, dispatch) {
 
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: getAuthentication(server, site),
      data: {
        login: username,
        password: password
      },
      type: "post",
      dataType: "json",
      beforeSend: function () {
        dispatch({ type: LOG_IN, username: username, site : site, server : server });
      },
      success: function (data) {
        if (data && data.token) {
          resolve(data);
        }
        else {
          reject(new Error("No token received"));
        }
      },
      error: function (error) {        
        reject(error);
      }
    });
  });

}

export function doSignIn(username, password, site) {
  let server = _.find(ISPyB.sites, { name : site}).server;
  return function (dispatch) {
    doLogin(server, username, password, site, dispatch)
      .then((data) => {
        
        dispatch({ type: LOGGED_IN, fullName: data.fullName ? data.fullName : username, token: data.token, roles: data.roles, username: username });
        dispatch(fetchProposals({ server : server, token : data.token}));
        
        //If user is manager then it fetches all today's sessions otherwise all user's sessions
        if (!_.find(data.roles, function (role) {
          return role === "Manager";
        })) {          
          dispatch(fetchSessions({ server : server, token : data.token}));
        } else {
          dispatch(fetchSessionsByDate({ server : server, token : data.token}, moment().format("YYYYMMDD"), moment().format("YYYYMMDD")));
        }

        // If analysis then load jobs 
        dispatch(loadJobs(username));

      })
      .catch((error) => {
        console.log(error)
        
        dispatch({ type: LOGIN_ERROR });
      })




    /*
    $.ajax({
      url: getAuthentication(site),
      data: {
        login: username,
        password: password
      },
      type: "post",
      dataType: "json",
      beforeSend: function () {
        dispatch({type: LOG_IN, username: username});
        //dispatch({type: SITE_SELECTED, site: site});
      },
      success: function (data) {
        if (data) {
          if (data.token) {
            dispatch({type: LOGGED_IN, fullName: data.fullName, token: data.token, roles: data.roles, username: username});
            dispatch(fetchProposals(data.token));
             //If user is manager then it fetches all today's sessions otherwise all user's sessions
            if (!_.find(data.roles, function (o) {
              return o === "Manager";
            })) {
              dispatch(fetchSessions(data.token));
            } else {
              dispatch(fetchSessionsByDate(data.token, moment().format("YYYYMMDD"), moment().format("YYYYMMDD")));
            }

            // If analysis then load jobs 
            dispatch(loadJobs(username));

          }
        }
      },
      error: function (error) {
        dispatch({type: LOGIN_ERROR, username: username, error: "Authentication Failed"});
      }
    });
    */


  };

}


// WEBPACK FOOTER //
// ./src/actions/login.js